import type { PausedConsultation } from 'types/pausedConsultation';
import { PausedConsultationCard } from './PausedConsultationCard';
import { Heading, List } from './PausedConsultations.styles';

interface PausedConsultationsPanelProps {
  label: string;
  consultations: PausedConsultation[];
  showPatient?: boolean;
}

export const PausedConsultationsPanel = ({
  label,
  consultations,
  showPatient = true,
}: PausedConsultationsPanelProps) => (
  <>
    <Heading>{label}</Heading>
    <List role="list" aria-label={label}>
      {consultations.map((consultation) => (
        <PausedConsultationCard
          key={consultation.interactionId}
          consultation={consultation}
          showPatient={showPatient}
        />
      ))}
    </List>
  </>
);
